import { useEffect, useMemo, useState } from 'react';
import CharacterCard from '@/components/cards/CharacterCard';
import CharacterDetailModal from '@/components/modals/CharacterDetailModal';
import * as characterService from '@/services/characterService';
import { RARITY } from '@/utils/characters';

const RARITY_ORDER = ['legendary', 'rare', 'uncommon', 'common'];

export default function CharactersPage() {
  const [characters, setCharacters] = useState([]);
  const [status, setStatus] = useState('A carregar habitantes...');
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState('all');

  const load = () => {
    characterService
      .getCharacters({}, { skipClientCache: true })
      .then((res) => {
        setCharacters(res.data.data || []);
        setStatus('');
      })
      .catch((err) => {
        setStatus(err.response?.data?.message || 'Não foi possível carregar os habitantes.');
      });
  };

  useEffect(() => {
    load();
  }, []);

  const filtered = useMemo(() => {
    const list = filter === 'all' ? characters : characters.filter((c) => c.rarity === filter);
    return [...list].sort(
      (a, b) => RARITY_ORDER.indexOf(a.rarity) - RARITY_ORDER.indexOf(b.rarity)
    );
  }, [characters, filter]);

  const filters = ['all', ...RARITY_ORDER];

  return (
    <main className="h-full overflow-y-auto bg-background px-4 pb-6 pt-4">
      <h1 className="font-urban text-3xl font-extrabold text-fg">Habitantes</h1>
      <p className="mt-1 text-sm text-muted">
        Cada pessoa do Porto guarda uma história. Aproxima-te para desvendar os seus segredos.
      </p>

      {/* rarity filter */}
      <div className="no-scrollbar mt-4 flex gap-2 overflow-x-auto pb-1">
        {filters.map((f) => {
          const active = filter === f;
          const meta = RARITY[f];
          const color = meta?.color || '#FF6030';
          return (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className="flex-shrink-0 rounded-full border px-3 py-1 font-micro text-[11px] font-bold uppercase tracking-wider transition"
              style={{
                color: active ? '#0D0D14' : color,
                background: active ? color : 'transparent',
                borderColor: color,
              }}
            >
              {f === 'all' ? 'Todos' : meta.label}
            </button>
          );
        })}
      </div>

      {status && <p className="mt-8 text-center text-sm text-muted">{status}</p>}

      {!status && filtered.length === 0 && (
        <p className="mt-8 text-center text-sm text-muted">Nenhum habitante nesta raridade ainda.</p>
      )}

      <div className="mt-4 grid grid-cols-1 gap-3">
        {filtered.map((character) => (
          <CharacterCard
            key={character.id}
            character={character}
            onClick={(c) => setSelected(c)}
          />
        ))}
      </div>

      <CharacterDetailModal
        characterKey={selected?.slug}
        isOpen={!!selected}
        onClose={() => { setSelected(null); load(); }}
      />
    </main>
  );
}
